import PayoutMethodService from "@/services/PayoutMethodService";
const state = () => ({
  list: []
});

const getters = {
  getList: state => state.list
};

const mutations = {
  setList(state, value) {
    state.list = value;
  }
};

const actions = {
  getList({ commit }, payload) {
    return PayoutMethodService.getList(payload).then(list => {
      commit("setList", list);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
